import styled from "styled-components";
import { borders } from "@sonder/ui/source/styled/theme";

export const LoginViewHeader = styled.div`
  display: flex;
  justify-content: center;
  border-bottom: ${borders.standard};
  padding: 0.63rem;
`;
